export default {
  YES: 'yes',
  NO: 'no',
  DONT_KNOW: 'dontKnow',
  UNKNOWN: 'unknown'
};